var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6, _g4, _path7, _g5, _path8, _g6, _g7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide6Planets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 722,
    height: 404,
    viewBox: "0 0 722 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1354 42.7791C34.7587 42.7791 42.5599 34.9779 42.5599 25.3546C42.5599 15.7314 34.7587 7.93018 25.1354 7.93018C15.5121 7.93018 7.71094 15.7314 7.71094 25.3546C7.71094 34.9779 15.5121 42.7791 25.1354 42.7791Z",
    fill: "url(#paint0_linear_7761_85303)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7761_85303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 36,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0206 37.0549C44.4748 29.9169 43.9204 18.8983 36.7825 12.4441C29.6445 5.98995 18.6259 6.54427 12.1717 13.6822C5.7175 20.8202 6.27182 31.8388 13.4098 38.293C20.5478 44.7472 31.5664 44.1929 38.0206 37.0549Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7761_85303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3572 54.5919C16.9382 45.5338 18.635 37.5285 20.4144 28.5531C21.9415 20.8567 21.9981 12.573 17.0774 6.04267C14.0755 2.07051 7.48855 6.23846 10.4905 10.2411C15.8549 17.3544 12.7703 26.2472 11.2127 34.1959C9.68563 41.8923 9.85097 49.4537 11.9088 57.0109C13.2445 61.8445 20.6929 59.3994 19.3572 54.5919Z",
    fill: "url(#paint1_linear_7761_85303)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7761_85303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 36,
    height: 36
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0206 37.0549C44.4748 29.9169 43.9204 18.8983 36.7825 12.4441C29.6445 5.98995 18.6259 6.54427 12.1717 13.6822C5.7175 20.8202 6.27182 31.8388 13.4098 38.293C20.5478 44.7472 31.5664 44.1929 38.0206 37.0549Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7761_85303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.696 54.5916C29.1689 45.2246 31.3617 36.223 33.3935 27.1345C34.2549 23.1884 35.5035 18.99 34.9205 14.9047C34.1983 10.2625 31.031 6.76025 27.8072 3.62342C24.2483 0.0384603 19.0797 5.87273 22.582 9.43159C26.0843 12.96 27.7506 15.7401 26.7804 20.8521C26.0016 24.6894 25.1141 28.4963 24.2527 32.3553C22.669 39.8037 21.6684 47.4173 22.917 54.9788C23.7523 59.8994 31.5314 59.5905 30.696 54.5916Z",
    fill: "url(#paint2_linear_7761_85303)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7761_85303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 36,
    height: 36
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0206 37.0549C44.4748 29.9169 43.9204 18.8983 36.7825 12.4441C29.6445 5.98995 18.6259 6.54427 12.1717 13.6822C5.7175 20.8202 6.27182 31.8388 13.4098 38.293C20.5478 44.7472 31.5664 44.1929 38.0206 37.0549Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7761_85303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0627 37.4202C37.034 31.1379 37.8128 23.968 39.8402 17.1331C41.8415 10.3243 43.0075 4.48998 41.0062 -2.40584C39.5879 -7.23944 32.17 -4.88138 33.6144 -0.0173244C35.9202 8.07058 31.6435 14.8794 30.6951 22.7454C29.8902 29.4716 30.8343 36.028 34.5585 41.7274C37.1993 45.8127 43.7863 41.6143 41.0627 37.4202Z",
    fill: "url(#paint3_linear_7761_85303)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M705.341 38.7799C711.571 38.7799 716.622 33.7291 716.622 27.4986C716.622 21.2681 711.571 16.2173 705.341 16.2173C699.11 16.2173 694.06 21.2681 694.06 27.4986C694.06 33.7291 699.11 38.7799 705.341 38.7799Z",
    fill: "url(#paint4_linear_7761_85303)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7761_85303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 693,
    y: 16,
    width: 24,
    height: 23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M713.643 35.088C717.821 30.4666 717.462 23.3327 712.841 19.154C708.22 14.9753 701.086 15.3342 696.907 19.9556C692.728 24.577 693.087 31.711 697.709 35.8897C702.33 40.0684 709.464 39.7094 713.643 35.088Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7761_85303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701.647 46.4218C700.09 40.531 701.173 35.3624 702.343 29.5543C703.318 24.551 703.344 19.217 700.203 14.9925C698.232 12.4082 693.977 15.1057 695.922 17.69C699.394 22.3017 697.397 28.0576 696.396 33.1958C695.422 38.1991 695.508 43.0892 696.84 47.9794C697.645 51.1467 702.509 49.5891 701.647 46.4218Z",
    fill: "url(#paint5_linear_7761_85303)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7761_85303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 693,
    y: 16,
    width: 24,
    height: 23
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M713.643 35.088C717.821 30.4666 717.462 23.3327 712.841 19.154C708.22 14.9753 701.086 15.3342 696.907 19.9556C692.728 24.577 693.087 31.711 697.709 35.8897C702.33 40.0684 709.464 39.7094 713.643 35.088Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7761_85303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M708.982 46.4243C708.007 40.3638 709.4 34.5295 710.731 28.6126C711.288 26.0544 712.093 23.3309 711.706 20.7205C711.262 17.7185 709.178 15.4692 707.094 13.3852C704.788 11.0794 701.425 14.8297 703.705 17.1355C705.984 19.4414 707.068 21.2469 706.402 24.5273C705.902 27.029 705.345 29.5001 704.762 31.9757C703.761 36.8093 703.096 41.756 703.9 46.62C704.457 49.87 709.513 49.6786 708.986 46.4243H708.982Z",
    fill: "url(#paint6_linear_7761_85303)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_7761_85303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 693,
    y: 16,
    width: 24,
    height: 23
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M713.643 35.088C717.821 30.4666 717.462 23.3327 712.841 19.154C708.22 14.9753 701.086 15.3342 696.907 19.9556C692.728 24.577 693.087 31.711 697.709 35.8897C702.33 40.0684 709.464 39.7094 713.643 35.088Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_7761_85303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.709 35.3086C713.098 31.2233 713.599 26.6116 714.93 22.1348C716.209 17.7145 716.988 13.9642 715.678 9.46125C714.76 6.35052 709.953 7.85148 710.897 11.0188C712.372 16.2439 709.618 20.6903 709.035 25.7458C708.508 30.0791 709.117 34.3341 711.536 38.0582C713.203 40.7252 717.458 38.0321 715.704 35.3086H715.709Z",
    fill: "url(#paint7_linear_7761_85303)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3501 342.199C62.0476 343.478 64.41 345.17 66.3547 347.202C67.2423 348.12 68.0515 349.09 68.7737 350.122C69.8875 351.705 70.8011 353.402 71.4972 355.208C71.7496 355.821 71.941 356.456 72.1629 357.096C73.8031 362.599 73.5246 368.686 70.8838 374.272C65.4106 385.889 51.8452 391.088 40.0897 386.363C39.7025 386.223 39.3109 386.028 38.9759 385.862C38.9194 385.836 38.8933 385.806 38.8106 385.78C36.5874 384.723 34.6122 383.361 32.8632 381.808C31.9452 380.972 31.1142 380.085 30.3355 379.141C24.6926 372.193 23.2221 362.356 27.3074 353.711C32.9764 341.677 47.3162 336.534 59.3501 342.208V342.199Z",
    fill: "url(#paint8_linear_7761_85303)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.881 347.454C61.6558 351.456 55.765 356.32 49.6218 361.737C42.7304 367.824 36.3088 373.854 30.8617 379.414C19.7196 390.726 12.4932 399.897 12.963 402.672C13.5199 406.062 25.1362 399.114 40.642 386.61C40.2548 386.471 39.8633 386.275 39.5283 386.109C37.5008 387.667 35.4995 389.168 33.4678 390.499C30.1047 392.696 26.5197 394.585 23.7962 394.337C23.7136 394.337 23.657 394.197 23.7397 394.058C23.8528 393.723 24.0181 393.419 24.1573 393.084C24.9926 391.474 26.1586 389.973 27.2985 388.555C28.7734 386.775 30.357 385.109 31.8841 383.525C32.4105 382.999 32.9109 382.498 33.4417 381.968C36.1086 379.327 38.8626 376.773 41.5557 374.271C43.222 372.714 44.8056 371.13 46.4458 369.546C48.7822 367.323 51.088 365.074 53.42 362.96C55.8085 360.793 58.2014 358.735 60.616 356.873C61.782 355.955 62.9784 355.124 64.2009 354.232C65.1189 353.536 66.0065 352.844 66.9245 352.174C67.7598 351.561 68.5647 350.926 69.4 350.369C70.6226 349.481 71.8451 348.646 73.0676 347.95C74.9558 346.836 76.9006 345.84 78.5147 345.753C78.6278 345.726 78.7365 345.866 78.6278 346.114C78.4624 346.392 78.3493 346.64 78.184 346.919C76.7396 349.338 75.0733 351.7 73.3765 353.949C72.9893 354.45 72.5716 355.006 72.1801 355.507C72.4324 356.12 72.6239 356.755 72.8457 357.395C82.9611 346.945 89.3827 338.583 88.965 335.942C88.2993 332.966 79.4066 337.83 66.8723 347.445L66.881 347.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M37.5049 342.895C37.8921 342.812 38.3098 342.699 38.7013 342.59C39.6454 342.369 40.6461 342.229 41.6467 342.286C42.5081 342.343 43.3696 342.508 44.0091 343.121C44.5921 343.678 45.1751 344.37 45.2056 345.205C45.2317 345.871 44.901 346.454 44.4573 346.954C43.5697 347.955 42.1514 348.621 41.3987 349.678C41.0376 350.178 41.0115 350.622 41.2856 351.179C41.5597 351.736 41.9817 351.984 42.6474 351.927C43.3435 351.871 44.0352 351.453 44.6182 351.122C45.3665 350.678 46.0931 350.148 46.7588 349.621C47.3722 349.177 47.9552 348.703 48.5948 348.373C48.8166 348.233 49.0385 348.151 49.2908 348.068C49.5127 347.903 49.7651 347.733 49.987 347.594C50.57 347.259 51.2922 346.954 51.9578 347.12C52.68 347.315 53.3457 348.038 53.3457 348.816C53.3718 349.817 52.68 350.596 52.4277 351.483C52.4538 351.731 52.5669 351.927 52.7061 352.149C52.9585 352.623 53.2326 353.067 53.6502 353.398C55.0947 354.733 57.3179 354.094 59.0973 354.037C60.0153 354.011 60.9028 354.12 61.7381 354.511C62.2646 354.651 62.7649 354.872 63.213 355.177C63.9091 355.651 64.379 356.4 64.4617 357.204C64.5182 357.483 64.4878 357.731 64.4356 358.009C64.4356 358.122 64.379 358.205 64.3529 358.314C64.131 358.979 63.7133 359.51 63.3261 360.119C63.1608 360.398 63.0216 360.702 62.8824 360.981L62.8563 361.007C62.6605 362.008 62.5213 362.982 62.5213 363.978C62.6039 364.701 62.8258 365.397 63.1042 366.119C63.5785 366.841 64.0222 367.594 64.466 368.342C64.8837 369.09 65.3274 369.9 65.5493 370.761C66.0758 372.845 65.297 374.82 64.2137 376.595C61.5728 380.876 57.1264 383.517 52.5408 385.406C50.235 386.38 47.8421 387.154 45.484 387.851C55.7647 389.434 66.2977 384.183 70.9703 374.316C73.6111 368.729 73.9157 362.643 72.2494 357.139C72.0536 356.5 71.8317 355.86 71.5837 355.251C70.8876 353.445 69.974 351.749 68.8602 350.165C68.138 349.138 67.3331 348.164 66.4412 347.246C64.4965 345.244 62.134 343.495 59.4366 342.242C52.1014 338.771 44.0396 339.297 37.5092 342.882L37.5049 342.895Z",
    fill: "#FEFBFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7761_85303",
    x1: 9.43953,
    y1: 7.28769,
    x2: 33.8045,
    y2: 40.6956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7761_85303",
    x1: 0.239844,
    y1: 12.8502,
    x2: 28.0435,
    y2: 50.9638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5292CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4675B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7761_85303",
    x1: 11.7499,
    y1: 11.09,
    x2: 39.9855,
    y2: 49.7971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5292CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4675B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7761_85303",
    x1: 25.0095,
    y1: 2.49085,
    x2: 49.0973,
    y2: 35.5141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5292CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4675B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7761_85303",
    x1: 695.686,
    y1: 15.8683,
    x2: 711.477,
    y2: 37.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7761_85303",
    x1: 690.425,
    y1: 19.3328,
    x2: 708.438,
    y2: 44.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5292CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4675B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7761_85303",
    x1: 697.861,
    y1: 18.2139,
    x2: 716.172,
    y2: 43.3111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5292CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4675B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7761_85303",
    x1: 706.494,
    y1: 12.6031,
    x2: 722.093,
    y2: 33.9827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5292CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4675B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7761_85303",
    x1: 28.3497,
    y1: 370.429,
    x2: 70.1829,
    y2: 346.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8EDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4361"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide6Planets);
export default __webpack_public_path__ + "static/media/slide_6_planets.7e90206e70ad1651d21d17863f125153.svg";
export { ForwardRef as ReactComponent };